import React, { useRef } from "react";
import Badge from "../UI/Badge";
import Spacing from "../Spacing";
import { Drawer } from 'vaul';

export default function MessageViewModal(props) {
  const {
    activeModal = false,
    setActiveModal = () => {},
    message_body = "",
    segment = "",
    type = "",
    previousScrollPosition = 0,
  } = props;
  const dropdownRef = useRef(null);

  const handleDrawerClose = () => {
    setActiveModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 medium">
            <Drawer.Title className="sr-only">View Details</Drawer.Title>
            <Drawer.Description className="sr-only">View a data details</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_auto">

              <div className="docpro_modal">
                <h2 className="docpro_fs_24 docpro_mb_0">{type === "note" ? "Note" : "Messages" } Details</h2>
                <Spacing lg="20" sm="20" />
                {segment !== null && (
                  <>
                    <span className="docpro_primary_color docpro_fw_500">
                      Total SMS{" "}
                      <Badge color="cyan" square>
                        {segment}
                      </Badge>
                    </span>
                    <Spacing lg="10" sm="10" />
                  </>
                )}
                <textarea
                  style={{
                    border: "1px solid var(--border)",
                    padding: "15px 15px",
                    fontSize: "16px",
                    borderRadius: "8px",
                    backgroundColor: "#fff",
                    resize: "none",
                  }}
                  className="docpro_form_field size_lg"
                  cols="30"
                  rows="12"
                  defaultValue={message_body}
                  readOnly
                ></textarea>

                <Spacing lg="32" sm="32" />
                <div className="docpro_modal_btns small_buttons docpro_mt_auto">
                  <button
                    className="docpro_bordered_btn docpro_fw_600 size_lg"
                    onClick={() => handleDrawerClose()}
                  >
                    Cancel
                  </button>
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
